import { useCallback } from "react";
import useEventListenerOutside from "./useEventListenerOutside.es.js";
const useOnFocusOutside = (handler, refs) => {
  const callback = useCallback(
    (event) => {
      if (event.eventPhase === Event.BUBBLING_PHASE && refs.some((ref) => ref.current && event.target.contains(ref.current)))
        return;
      handler(event);
    },
    [handler, refs]
  );
  useEventListenerOutside(callback, "focusin", refs);
};
export {
  useOnFocusOutside as default
};
//# sourceMappingURL=useOnFocusOutside.es.js.map
